<div class="admin-modal" role="dialog" aria-modal="true">
  <div class="admin-modal__backdrop" (click)="closeModal()"></div>

  <div class="admin-modal__card">
    <button
      type="button"
      class="admin-modal__close"
      (click)="closeModal()"
      aria-label="Close create user modal"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.4"
          d="M6 6l12 12M18 6 6 18"
        />
      </svg>
    </button>

    <div class="admin-modal__copy">
      <h2>{{ mode === "CREATE" ? "Create New User" : "Update Existing User" }}</h2>
      <p>{{ mode === "CREATE" ? "Fill in the details to create a new admin user account" : "Fill in the details to update the exisiting admin user account"}}</p>
    </div>

    <form
      class="admin-modal__form"
      [formGroup]="userForm"
      (ngSubmit)="submit()"
    >
      <div class="admin-modal__grid">
        <label class="admin-modal__field">
          <span>First Name</span>
          <input
            [appCharLength]
            type="text"
            formControlName="firstName"
            placeholder="e.g. James"
            [disabled]="isSubmitting"
            [class.admin-modal__control--invalid]="hasError('firstName')"
          />
          <small *ngIf="hasError('firstName')" class="admin-modal__error">{{
            getFirstNameError()
          }}</small>
        </label>

        <label class="admin-modal__field">
          <span>Last Name</span>
          <input
            [appCharLength]
            type="text"
            formControlName="lastName"
            placeholder="e.g. Ojii"
            [disabled]="isSubmitting"
            [class.admin-modal__control--invalid]="hasError('lastName')"
          />
          <small *ngIf="hasError('lastName')" class="admin-modal__error">{{
            getLastNameError()
          }}</small>
        </label>

        <label class="admin-modal__field">
          <span>Email</span>
          <input
            [appCharLength]
            type="email"
            formControlName="email"
            placeholder="example@gmail.com"
            [disabled]="isSubmitting"
            [class.admin-modal__control--invalid]="hasError('email')"
          />
          <small *ngIf="hasError('email')" class="admin-modal__error">{{
            getEmailError()
          }}</small>
        </label>

        <label class="admin-modal__field">
          <span>Phone Number</span>
          <input
            type="tel"
            formControlName="phoneNumber"
            placeholder="e.g. 0707663522"
            [disabled]="isSubmitting"
            [class.admin-modal__control--invalid]="hasError('phoneNumber')"
          />
          <small *ngIf="hasError('phoneNumber')" class="admin-modal__error">{{
            getPhoneNumberError()
          }}</small>
        </label>

        <label class="admin-modal__field">
          <span>ASIN <em>(Optional)</em></span>
          <input
            type="text"
            formControlName="asin"
            placeholder="e.g. 123456789"
            [disabled]="isSubmitting"
            [class.admin-modal__control--invalid]="hasError('asin')"
          />
          <small *ngIf="hasError('asin')" class="admin-modal__error">{{
            getAsinError()
          }}</small>
        </label>

        <label class="admin-modal__field" for="roles">
          <span>Roles</span>
          <!-- <div class="admin-modal__select-wrap">
            <select
              formControlName="role"
              [disabled]="isSubmitting"
              [class.admin-modal__control--invalid]="hasError('role')"
            >
              <option value="">-- Select Role --</option>
              <option *ngFor="let role of roleOptions" [value]="role.id">
                {{ role.name }}
              </option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m19 9-7 7-7-7"
              />
            </svg>
          </div> -->
          <ng-select
            id="roles" 
            [items]="roleOptions"
            bindLabel="name"
            bindValue="id"
            [multiple]="true"
            [clearable]="true"
            [class.admin-modal__control--invalid]="hasError('roles')"
            formControlName="roles"
            placeholder="-- Select Role --">
          </ng-select>
          <small *ngIf="hasError('roles')" class="admin-modal__error">{{
            getRolesError()
          }}</small>
        </label>

        <label class="admin-modal__field">
          <span>MDA</span>
          <div class="admin-modal__select-wrap">
            <select
              formControlName="mda"
              [disabled]="isSubmitting"
              [class.admin-modal__control--invalid]="hasError('mda')"
            >
              <option value="">-- Select MDA --</option>
              <option *ngFor="let mda of mdaOptions" [value]="mda.id">
                {{ mda.name }}
              </option>
            </select>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m19 9-7 7-7-7"
              />
            </svg>
          </div>
          <small *ngIf="hasError('mda')" class="admin-modal__error">{{
            getMdaError()
          }}</small>
        </label>
      </div>

      <button type="submit" class="mt-4 w-full page-btn page-btn-primary" [disabled]="!canSubmit">
        @if (mode === "CREATE") {
          <span>{{ isSubmitting ? "Creating User..." : "Create User" }}</span>
        } @else {
          <span>{{ isSubmitting ? "Updating User..." : "Update User" }}</span>
        }
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 12h14m-4-4 4 4-4 4"
          />
        </svg>
      </button>
    </form>
  </div>
</div>
